export const resolveRelations = [
  "home.footer_cta_override",
  "page.footer_cta_override",
  "project.footer_cta_override",
  "layoutCallToAction.call_to_action",
  "layoutPaths.paths",
  "spotlightListing.spotlight",
];

export const menuRelations = [
  "serviceMegaMenu.featured",
  "sectionMegaMenu.featured",
  "staffMegaMenu.featured",
  "pageGroup.pages",
  "storyPost.tags",
];

export const projectFooterRelations = ["snippetBloks.bloks"];

export const footerRelations = [
  "home.footer_cta_override",
  "page.footer_cta_override",
  "project.footer_cta_override",
];
